import axios from "axios";

const DEFAULT_MAX_CONTENT_LENGTH = 200 * 1024 * 1024; // 200 Mo par défaut

let api = axios.create({
  maxContentLength: DEFAULT_MAX_CONTENT_LENGTH, // Configurer globalement la taille maximale de la charge utile // rt. 06.08.24
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

api.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  if (error.response?.status === 403) {
    // window.location.href="/login"
  }
  return Promise.reject(error);
});

export default api